import { SubAPI } from "./SubAPI";
export class DDLOptions extends SubAPI {
    list(props) { return this.fetcher.get("/api/opening/defaults", props); }
    upsert(input) { return this.fetcher.post("/api/opening/default", input); }
    reSort(input) { return this.fetcher.post("/api/opening/default/re-sort", input); }
    upsertDefaultLiteKitProfile(input) { return this.fetcher.post("/api/opening/default/lite-kit-profile", input); }
}
